import { Component, Input, OnInit } from '@angular/core';
import { ProjectItem } from 'src/app/shared/models/base.models';

@Component({
  selector: 'app-space-mini-card',
  templateUrl: './space-mini-card.component.html',
  styleUrls: ['./space-mini-card.component.css']
})
export class SpaceMiniCardComponent implements OnInit {
  @Input() space: ProjectItem
  constructor() { }

  ngOnInit() {
  }

}
